import { WebAppProject } from "./project/WebAppProject";
import { WebApp } from "./WebApp";

export class WebAppComponent<C,P extends WebAppProject>
{
  protected _webApp:WebApp<C,P>;
  get webApp(){ return this._webApp; }
  
  constructor( webApp:WebApp<C,P> )
  {
    this._webApp = webApp;
  }
}